/**
 * @file Tag Button component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../components/global/Button';

const propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  tagStyle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  size: PropTypes.oneOf(['lg', 'sm', 'xs']),
  selected: PropTypes.bool,
};

const TagButton = ({
  name,
  onClick,
  className,
  tagStyle,
  size,
  children,
  selected,
  ...props
}) => {
  const classes = classNames({
    'tag-button': true,
    'is-selected': selected,
    [`tag-button-${size}`]: !!size,
    [className]: !!className,
  });

  return (
    <Button
      btnStyle={tagStyle}
      onClick={onClick}
      className={classes}
      type="button"
      {...props}
    >
      {name}
      {children}
    </Button>
  );
};

TagButton.propTypes = propTypes;

export default TagButton;
